import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentsIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M13.1488 6.3275C13.0963 6.32 13.0438 6.32 12.9913 6.3275C11.8287 6.29 10.9062 5.3375 10.9062 4.1675C10.9062 2.975 11.8738 2 13.0738 2C14.2663 2 15.2413 2.9675 15.2413 4.1675C15.2338 5.3375 14.3113 6.29 13.1488 6.3275Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M15.5917 11.5251C14.7517 12.0876 13.5742 12.2976 12.4867 12.1551C12.7717 11.5401 12.9217 10.8576 12.9292 10.1376C12.9292 9.38756 12.7642 8.67506 12.4492 8.05256C13.5592 7.90256 14.7367 8.11256 15.5842 8.67506C16.7692 9.45506 16.7692 10.7376 15.5917 11.5251Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M4.83109 6.3275C4.88359 6.32 4.93609 6.32 4.98859 6.3275C6.15109 6.29 7.07359 5.3375 7.07359 4.1675C7.07359 2.9675 6.10609 2 4.90609 2C3.71359 2 2.74609 2.9675 2.74609 4.1675C2.74609 5.3375 3.66859 6.29 4.83109 6.3275Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M4.91234 10.1375C4.91234 10.865 5.06984 11.555 5.35484 12.1775C4.29734 12.29 3.19484 12.065 2.38484 11.5325C1.19984 10.745 1.19984 9.46246 2.38484 8.67496C3.18734 8.13496 4.31984 7.91746 5.38484 8.03746C5.07734 8.66746 4.91234 9.37996 4.91234 10.1375Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M9.09156 12.4025C9.03156 12.395 8.96406 12.395 8.89656 12.4025C7.51656 12.3575 6.41406 11.225 6.41406 9.83C6.42156 8.405 7.56906 7.25 9.00156 7.25C10.4266 7.25 11.5816 8.405 11.5816 9.83C11.5741 11.225 10.4791 12.3575 9.09156 12.4025Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M6.65406 13.955C5.52156 14.7125 5.52156 15.9575 6.65406 16.7075C7.94406 17.57 10.0591 17.57 11.3491 16.7075C12.4816 15.95 12.4816 14.705 11.3491 13.955C10.0666 13.0925 7.95156 13.0925 6.65406 13.955Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_7)
  ]))
}
}

})